import axios from 'axios'

export const saveProject = ({ title }) => {
  return (dispatch, getState) => {
    axios({
      method: 'POST', 
      url: '/api/project/new', 
      data: `name=${title}`
    }).then((resp) => {
      const identifier = resp.data.identifier
      window.location.replace(`/${identifier}`)
    })
  }
}

